export default __webpack_public_path__ + "static/media/js.ba0a9285.png";